import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ConflictStateService {

	private readonly LAST_CONFLICT_RESOLVED = 'LAST_CONFLICT_RESOLVED';

	constructor() {
	}

	public setLastConflictResolved(value: boolean): void {
		window.localStorage.setItem(this.LAST_CONFLICT_RESOLVED, value ? 'true' : 'false');
	}

	/**
	 * @returns true if there is no any pending conflict migration. false - if there is at least one. Supposed to be used
	 * to prevent user notifying about conflict that happen.
	 */
	public isLastConflictResolved(): boolean {
		return window.localStorage.getItem(this.LAST_CONFLICT_RESOLVED) === 'true';
	}
}
